import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.contentmap.reproveAbilityConfirmation.title',
    defaultMessage: 'HABILITY REPROVED',
  },
  subtitle: {
    id: 'simulated.contentmap.reproveAbilityConfirmation.subtitle',
    defaultMessage: 'New ability successfully reproved.',
  },
  continue: {
    id: 'simulated.contentmap.reproveAbilityConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
